import { render, staticRenderFns } from "./NumericKeyboardComponent.vue?vue&type=template&id=789487fd&scoped=true&"
import script from "./NumericKeyboardComponent.vue?vue&type=script&lang=js&"
export * from "./NumericKeyboardComponent.vue?vue&type=script&lang=js&"
import style0 from "./NumericKeyboardComponent.vue?vue&type=style&index=0&id=789487fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789487fd",
  null
  
)

export default component.exports